import { RECORD_TYPE } from "../const/constants";

/**
 * Shared plumbing for the "<X> Defaults" buttons on the WM Data Profile screens, which open a
 * target data-entry screen on the profile's own RECORDTYPE = 'P' template record (Delphi
 * SetParameters). The profile screen builds the URL with buildProfileDefaultsUrl; the target screen
 * reads it back with readProfileDefaults.
 *
 * The query-string keys live here once so the two sides cannot drift apart. They are the same keys
 * the Charge Profile and Crate Profile screens already use.
 */
export const PROFILE_DEFAULTS_PARAMS = {
    RECORD_TYPE: 'recordType',
    PROFILE_ROW_ID: 'RProfile',
    PROFILE_CODE: 'profileCode',
    TEMPLATE_ROW_ID: 'id',
};

/**
 * Reads the profile-defaults route parameters. A record that was opened for edit carries its record
 * type in state, so currentRecordType counts as well as the URL.
 */
export const readProfileDefaults = (search, currentRecordType) => {
    const params = new URLSearchParams(search);
    return {
        isProfileDefaults:
            params.get(PROFILE_DEFAULTS_PARAMS.RECORD_TYPE) === RECORD_TYPE.PROFILE_DEFAULTS
            || currentRecordType === RECORD_TYPE.PROFILE_DEFAULTS,
        profileRowId: params.get(PROFILE_DEFAULTS_PARAMS.PROFILE_ROW_ID),
        profileCode: params.get(PROFILE_DEFAULTS_PARAMS.PROFILE_CODE),
    };
};

/**
 * An existing template goes to the target's Edit route by the TEMPLATE's RowId (never the
 * profile's); a profile with no template yet goes to the Create route, which seeds the row from
 * RProfile. Both carry RProfile so Back can find its way home.
 */
export const buildProfileDefaultsUrl = ({ createRoute, editRoute, templateRowId, profileRowId, profileCode }) => {
    const params = new URLSearchParams();
    if (templateRowId) {
        params.set(PROFILE_DEFAULTS_PARAMS.TEMPLATE_ROW_ID, templateRowId);
    }
    params.set(PROFILE_DEFAULTS_PARAMS.RECORD_TYPE, RECORD_TYPE.PROFILE_DEFAULTS);
    params.set(PROFILE_DEFAULTS_PARAMS.PROFILE_ROW_ID, profileRowId);
    params.set(PROFILE_DEFAULTS_PARAMS.PROFILE_CODE, profileCode || '');

    return `${templateRowId ? editRoute : createRoute}?${params.toString()}`;
};

/**
 * Strips every required rule from a layout, for a profile template. Delphi SetParameters clears the
 * target query's NonBlankFields for that record, so the template may be saved with nothing filled in.
 * A schema variant is used rather than toggling editors after render, because the required rule is
 * compiled into the validator when the field is built.
 */
export const relaxRequiredForProfileDefaults = (layout) => layout.map(group => ({
    ...group,
    fields: group.fields.map(field => (field.required ? { ...field, required: false } : field)),
}));
